// On rateplan change it:
// 1. (single group) Updates the Book button with the selected rateplan
// 2. (multi-group) saves selected rateplan so Choose button can use it
stimulusApp.register(
  "room-details",
  class extends Stimulus.Controller {
    static targets = ["book", "bookBtn", "ratePlan", "notEnoughRooms"]
    static outlets = ["room-card"]

    connect() {
      if (this.hasRoomCardOutlet && this.roomCardOutlet.isAvailable()) {
        this.#showBookButton()
      } else {
        this.#showNotEnoughRoomsMessage()
      }

      this.handleRatePlanChange()
    }

    handleRatePlanChange() {
      const ratePlan = this.#selectedRatePlan()
      if (!ratePlan) return

      this.#updateButtons(ratePlan)
    }

    saveChoice() {
      const ratePlan = this.#selectedRatePlan()

      if (ratePlan && this.hasRoomCardOutlet) {
        this.roomCardOutlet.chooseRatePlan(ratePlan.dataset.ofuuid)
      }
    }

    #selectedRatePlan() {
      return this.ratePlanTargets.find((plan) => plan.checked)
    }

    #updateButtons(ratePlan) {
      if (this.hasBookTarget) {
        const bookElement = this.bookTarget
        const url = new URL(
          bookElement.getAttribute("href"),
          window.location.origin,
        )
        url.searchParams.set("rooms[]", ratePlan.dataset.ofuuid)
        url.searchParams.delete("rate_plans")
        bookElement.setAttribute("href", url.toString())
      }
    }

    #showBookButton() {
      if (this.hasBookBtnTarget) {
        this.bookBtnTarget.classList.remove("hidden")
      }
      if (this.hasNotEnoughRoomsTarget) {
        this.notEnoughRoomsTarget.classList.add("hidden")
      }
    }

    #showNotEnoughRoomsMessage() {
      if (this.hasBookBtnTarget) {
        this.bookBtnTarget.classList.add("hidden")
      }
      if (this.hasNotEnoughRoomsTarget) {
        this.notEnoughRoomsTarget.classList.remove("hidden")
      }
    }
  },
)
